import React from 'react';
import { Redirect } from 'react-router';
import { ERoutesMentor } from 'common/models/routesModel';

export const RootMentorPage: React.FC = () => <Redirect to={ERoutesMentor.RequestList} />;
